var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"switchlang"}},[_c('p',{on:{"click":function($event){return _vm.setlocate()}}},[_vm._v(_vm._s(_vm.langs.toUpperCase()))])])}
var staticRenderFns = []

export { render, staticRenderFns }